import React, { createContext } from "react";

import { PlayerEmbedParams } from "../types/common";

export const EmbedParametersContext = createContext<
  PlayerEmbedParams | undefined
>(undefined);

export const useEmbedParametersContext = () => {
  const context = React.useContext(EmbedParametersContext);
  if (context === undefined) {
    throw new Error("EmbedParametersContext not found");
  }
  return context;
};
